import Image from 'next/image'

type Props = {
  /** CSS height for the logo; width follows aspect ratio */
  height?: number
  className?: string
  priority?: boolean
}

/** Primary mark: rounded Sigma + trend icon in /public/brand/sigma-mark.png */
export function PortalLogo({ height = 40, className, priority }: Props) {
  return (
    <Image
      src="/brand/sigma-mark.png"
      alt="SigmaSense"
      width={512}
      height={512}
      className={className}
      style={{
        height,
        width: height,
        borderRadius: Math.round(height * 0.22),
        objectFit: 'cover',
      }}
      priority={priority}
    />
  )
}
